import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "ISSUERCONFIG";
export const issuerConfigConstants = createCRUDConstants(nameSpace, [
  "DELETE"
]);
